export default "__VITE_ASSET__g5LkJKcd__"